import { parseAsInteger, useQueryStates } from 'nuqs';
import { useContext, useEffect } from 'react';

import { FileFilterContext } from '../FileFilterContext';

export const useFileFilters = () => {
  const { dispatchFileFilters, fileFilters } = useContext(FileFilterContext);

  const [, setFileFilterQuery] = useQueryStates({
    folderId: parseAsInteger,
  });

  useEffect(() => {
    void setFileFilterQuery(
      {
        folderId: fileFilters?.folderId ?? null,
      },
      { history: 'replace' },
    );
  }, [fileFilters?.folderId, setFileFilterQuery]);

  return { fileFilters, dispatchFileFilters };
};
